<template>
  <ContingentForm />
</template>

<script>
import ContingentForm from "@/components/contingent/ContingentForm.vue";

export default {
  name: "ContingentCreatePage",
  components: {
    ContingentForm,
  },
};
</script>
